import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import ExitToAppRoundedIcon from '@material-ui/icons/ExitToAppRounded';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';

import KeycloakState from '../../auth/KeycloakState';

interface Props {
    keycloakState: KeycloakState;
}

type ButtonsProps = Props & {
    keycloakState: KeycloakState;
};

const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
    },
}));

const Buttons: FC<ButtonsProps> = (props) => {
    const classes = useStyles();
    const keycloakState = props.keycloakState;

    function logout() {
        if (keycloakState.keycloak != null) {
            keycloakState.keycloak.logout({
                redirectUri: window.location.origin
                    ? window.location.origin + '/'
                    : window.location.protocol + '/' + window.location.host + '/',
            });
        }
    }

    return (
        <div>
            <Button
                variant="contained"
                startIcon={<ArrowBackIosRoundedIcon />}
                className={classes.button}
            >
                <a
                    // @ts-ignore
                    href={window.rocAppConfig.backToAdminPortalUrl}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    Admin Portal
                </a>
            </Button>
            <Button variant="contained" onClick={() => logout()} startIcon={<ExitToAppRoundedIcon />}>
                Logout
            </Button>
        </div>
    );
};

export default Buttons;
